import React from 'react';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import './VideoPresent.css';
import Popup from '../../Popup/Popup.jsx'
import Calendars from './Calendars/Calendars'
import tw from '../../../img/share-logos/tw.svg'
import fb from '../../../img/share-logos/fb.svg'
import ln from '../../../img/share-logos/ln.svg'

export default class VideoPresent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideSpeakers: true,
      hideCalendars: [],
      hideShares: [],
      hideSocials: [],
    }

    this.toggleSpeakers = this.toggleSpeakers.bind(this);
    this.toggleCalendars = this.toggleCalendars.bind(this);
    this.toggleShares = this.toggleShares.bind(this);
    this.toggleSocials = this.toggleSocials.bind(this);
    this.clearArr = this.clearArr.bind(this);
  }

  toggleSpeakers() {
    this.setState({ hideSpeakers: !this.state.hideSpeakers });
  }

  clearArr() {
    document.querySelector('body').style.overflow = 'visible';
    this.setState({ hideCalendars: [] });
    this.setState({ hideShares: [] });
    this.setState({ hideSocials: [] });
  }

  toggleCalendars(name) {
    document.querySelector('body').style.overflow = 'hidden';
    if (this.state.hideCalendars.indexOf(name) > -1) {
      let index = this.state.hideCalendars.indexOf(name);
      if (index !== -1) {
        document.querySelector('body').style.overflow = 'visible';
        this.setState({
          hideCalendars: this.state.hideCalendars.filter(function (item) {
            return item !== name
          })
        });
      }
    } else {
      this.setState({ hideCalendars: [...this.state.hideCalendars, name] })
    }
  }

  toggleShares(name) {
    document.querySelector('body').style.overflow = 'hidden';
    if (this.state.hideShares.indexOf(name) > -1) {
      let index = this.state.hideShares.indexOf(name);
      if (index !== -1) {
        document.querySelector('body').style.overflow = 'visible';
        this.setState({
          hideShares: this.state.hideShares.filter(function (item) {
            return item !== name
          })
        });
      }
    } else {
      this.setState({ hideShares: [...this.state.hideShares, name] })
    }
  }

  toggleSocials(name) {
    document.querySelector('body').style.overflow = 'hidden';
    if (this.state.hideSocials.indexOf(name) > -1) {
      let index = this.state.hideSocials.indexOf(name);
      if (index !== -1) {
        document.querySelector('body').style.overflow = 'visible';
        this.setState({
          hideSocials: this.state.hideSocials.filter(function (item) {
            return item !== name
          })
        });
      }
    } else {
      this.setState({ hideSocials: [...this.state.hideSocials, name] })
    }
  }

  componentDidMount() {
    document.addEventListener('click', () => {
      if (this.state.hideCalendars.length > 1) {
        this.clearArr();
      }
    })
  }

  renderVideoPresent(item, i) {
    return (
      <React.Fragment>
        <div className='speaker_item'>
          <div className={`speaker_track ${item.track === 'Pro' && 'senior'}`}>{item.track === 'Junior' ? 'junior track 🤓' : 'senior track 🔥'}</div>
          <div className='speaker_info-wrap'>
            <div style={{ backgroundImage: `url(${item.photo}` }} className='speaker_info'>
              <p className='speaker_name p1'>{item.name}</p>
              <p className='speaker_position grey p2'>{item.position}</p>
              {item.logo && <img className='speaker_logo' src={item.logo} alt="" />}
              {item.company && <p className='company_name'>{item.company}</p>}
              {item.two &&
                <div>
                  <p className='speaker_name p1'>{item.name2}</p>
                  <p className='speaker_position grey p2'>{item.position2}</p>
                  <img className='speaker_logo' src={item.logo2} alt="" />
                  {item.logo2 && <img className='speaker_logo' src={item.logo2} alt="" />}
                  {item.company2 && <p className='company_name'>{item.company2}</p>}
                </div>
              }
            </div>
          </div>
          <div className='speaker_title'>
            <p className='speaker_title--content p1'>"{item.title}"</p>
          </div>
          <div className='speaker_menu'>
            <Popup quotes={true} video={item.video} desc2={item.bio} title={item.title} title2='More about speaker' desc={item.abstract} key={i} />
            <div onClick={() => this.toggleCalendars(item.name)} className={`calendars ${(this.state.hideCalendars.length > 0 && this.state.hideCalendars.indexOf(item.name) !== -1) && 'active'}`}>
              <Calendars />
            </div>
            <button onClick={() => this.toggleShares(item.name)} className={`speaker_menu--item ${(this.state.hideShares.length > 0 && this.state.hideShares.indexOf(item.name) !== -1) && 'active'}`}>
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.369 12.3703C15.7914 12.3741 15.2218 12.5058 14.7012 12.756C14.1805 13.0062 13.7218 13.3686 13.3579 13.8172L8.3719 11.5197C8.60633 10.8019 8.60633 10.0281 8.3719 9.31024L13.3579 7.01278C13.946 7.72252 14.766 8.20167 15.6731 8.36568C16.5801 8.52969 17.516 8.36802 18.3155 7.90918C19.1149 7.45035 19.7266 6.72387 20.0426 5.85793C20.3585 4.992 20.3584 4.04229 20.0423 3.17642C19.7262 2.31055 19.1144 1.58417 18.3148 1.12548C17.5153 0.666799 16.5794 0.505292 15.6724 0.669468C14.7653 0.833644 13.9455 1.31295 13.3574 2.02279C12.7694 2.73263 12.451 3.62738 12.4584 4.54912C12.4614 4.78203 12.4843 5.01425 12.5269 5.24325L7.36493 7.61892C6.81459 7.0808 6.1177 6.71706 5.36155 6.57326C4.6054 6.42946 3.82363 6.512 3.11419 6.81054C2.40474 7.10908 1.79917 7.61034 1.37335 8.25152C0.947524 8.89269 0.720383 9.64528 0.720383 10.415C0.720383 11.1847 0.947524 11.9373 1.37335 12.5784C1.79917 13.2196 2.40474 13.7209 3.11419 14.0194C3.82363 14.318 4.6054 14.4005 5.36155 14.2567C6.1177 14.1129 6.81459 13.7492 7.36493 13.211L12.5269 15.5867C12.4843 15.8157 12.4614 16.0479 12.4584 16.2808C12.4584 17.0543 12.6878 17.8103 13.1175 18.4534C13.5472 19.0965 14.1579 19.5977 14.8725 19.8937C15.5871 20.1897 16.3734 20.2672 17.1319 20.1163C17.8905 19.9654 18.5873 19.5929 19.1342 19.046C19.6811 18.4991 20.0536 17.8023 20.2044 17.0437C20.3553 16.2852 20.2779 15.4989 19.9819 14.7843C19.6859 14.0698 19.1847 13.459 18.5416 13.0293C17.8985 12.5996 17.1425 12.3703 16.369 12.3703ZM16.369 2.59384C16.7557 2.59384 17.1338 2.70851 17.4553 2.92336C17.7769 3.13821 18.0275 3.44359 18.1755 3.80087C18.3235 4.15815 18.3622 4.55129 18.2867 4.93058C18.2113 5.30987 18.0251 5.65827 17.7516 5.93172C17.4782 6.20517 17.1298 6.39139 16.7505 6.46684C16.3712 6.54228 15.978 6.50356 15.6208 6.35557C15.2635 6.20758 14.9581 5.95697 14.7433 5.63542C14.5284 5.31388 14.4137 4.93584 14.4137 4.54912C14.4137 4.03055 14.6197 3.53321 14.9864 3.16653C15.3531 2.79984 15.8504 2.59384 16.369 2.59384ZM4.63731 12.3703C4.25059 12.3703 3.87255 12.2556 3.55101 12.0407C3.22946 11.8259 2.97885 11.5205 2.83086 11.1632C2.68287 10.806 2.64415 10.4128 2.71959 10.0335C2.79504 9.65423 2.98126 9.30583 3.25471 9.03238C3.52816 8.75893 3.87656 8.57271 4.25585 8.49726C4.63514 8.42182 5.02828 8.46054 5.38556 8.60853C5.74284 8.75652 6.04822 9.00714 6.26307 9.32868C6.47792 9.65022 6.59259 10.0283 6.59259 10.415C6.59259 10.9336 6.38659 11.4309 6.0199 11.7976C5.65321 12.1643 5.15588 12.3703 4.63731 12.3703ZM16.369 18.2361C15.9823 18.2361 15.6043 18.1214 15.2827 17.9066C14.9612 17.6917 14.7106 17.3864 14.5626 17.0291C14.4146 16.6718 14.3759 16.2787 14.4513 15.8994C14.5267 15.5201 14.713 15.1717 14.9864 14.8982C15.2599 14.6248 15.6083 14.4386 15.9876 14.3631C16.3668 14.2877 16.76 14.3264 17.1173 14.4744C17.4746 14.6224 17.7799 14.873 17.9948 15.1945C18.2096 15.5161 18.3243 15.8941 18.3243 16.2808C18.3243 16.7994 18.1183 17.2967 17.7516 17.6634C17.3849 18.0301 16.8876 18.2361 16.369 18.2361Z" fill="#A7A7A7" />
              </svg>
              <span className='speaker_menu--text'>Share</span>
              {(this.state.hideShares.indexOf(item.name) > -1) && <div className='speaker_open-menu'>
                <TwitterShareButton url='https://events.geekle.us/uiux23/' title={`Check out the presentation from ${item.name} ${item.two ? 'and ' + item.name2 + ' ' : ''}on ${item.track === 'Junior' ? 'March 21, 2023' : 'March 22, 2023'} at UI/UX Global Summit'23!`}>
                  <img src={tw} alt="" />
                </TwitterShareButton>
                <LinkedinShareButton url='https://events.geekle.us/uiux23/' title={`Check out the presentation from ${item.name} on ${item.track === 'Junior' ? 'March 21, 2023' : 'March 22, 2023'} at UI/UX Global Summit'23!`}>
                  <img src={ln} alt="" />
                </LinkedinShareButton>
                <FacebookShareButton url='https://events.geekle.us/uiux23/' hashtag='#geekle' quote={`Check out the presentation from ${item.name} on ${item.track === 'Junior' ? 'March 21, 2023' : 'March 22, 2023'} at UI/UX Global Summit'23!`}>
                  <img src={fb} alt="" />
                </FacebookShareButton>
              </div>}
            </button>
            <button onClick={() => this.toggleSocials(item.name)} className={`speaker_menu--item ${(this.state.hideSocials.length > 0 && this.state.hideSocials.indexOf(item.name) !== -1) && 'active'}`}>
              <svg width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M22.5558 0.980469H0.444092V16.6209H5.97201L11.4999 20.5093L17.0279 16.6209H22.5558V0.980469ZM14.1478 6.47514C14.1478 7.93807 12.9629 9.12297 11.4999 9.12297C10.037 9.12297 8.85211 7.93807 8.85211 6.47514C8.85211 5.01221 10.037 3.82731 11.4999 3.82731C12.9629 3.82731 14.1478 5.01221 14.1478 6.47514ZM6.20428 12.4328C6.20428 10.672 9.73252 9.78493 11.4999 9.78493C13.2674 9.78493 16.7956 10.672 16.7956 12.4328V13.7567H6.20428V12.4328Z" fill="#A7A7A7" />
              </svg>
              <span className='speaker_menu--text'>Follow</span>
              {(this.state.hideSocials.indexOf(item.name) > -1) && <div className='speaker_open-menu'>
                {item.tw && <a className='social_link social_tw' target='_blank' rel="noreferrer" href={item.tw}></a>}
                {item.github && <a className='social_link social_github' target='_blank' rel="noreferrer" href={item.github}></a>}
                {item.ln && <a className='social_link social_ln' target='_blank' rel="noreferrer" href={item.ln}></a>}
                {item.ln2 && <a className='social_link social_ln' target='_blank' rel="noreferrer" href={item.ln2}></a>}
                {item.fb && <a className='social_link social_fb' target='_blank' rel="noreferrer" href={item.fb}></a>}
                {item.website && <a className='social_link social_website' target='_blank' rel="noreferrer" href={item.website}></a>}
                {item.website2 && <a className='social_link social_website' target='_blank' rel="noreferrer" href={item.website2}></a>}
                {item.inst && <a className='social_link social_inst' target='_blank' rel="noreferrer" href={item.inst}></a>}
                {item.yb && <a className='social_link social_yb' target='_blank' rel="noreferrer" href={item.yb}></a>}
              </div>}
            </button>
          </div>
        </div>
      </React.Fragment>
    )
  }

  render() {
    return (
      <>
        <div onClick={this.clearArr} className={`${(this.state.hideCalendars.length > 0 || this.state.hideShares.length > 0 || this.state.hideSocials.length > 0) ? 'active' : ''} bg_blur`}></div>
        <div className="videoPresent container">
          <h2 className='speakers_h2 colorful'>Our speakers from previous event</h2>
          <div className="video_block">
            <div className='video_half senior'>
              <div className="video_header senior">
                <h3 className="video_half--title">Senior Track 🔥</h3>
                <p className="video_half--talks p1">Talks #11 - #24</p>
                <p className='video_half--subtitle p1'>For Middle and Senior specialists</p>
              </div>
              <div className='speaker_items'>
                {this.props.speakersSenior.map((item, i) => <React.Fragment key={`videoPresent_item-${i}`}>{this.renderVideoPresent(item, i)}</React.Fragment>)}
                {!this.state.hideSpeakers && this.props.speakerSeniorHide.map((item, i) => this.renderVideoPresent(item, i))}
              </div>
              {/* <p className='more_speakers'>More speakers to be announced soon</p> */}
              <button className='video_btn button' onClick={this.toggleSpeakers}>{this.state.hideSpeakers ? 'Show more speakers' : 'Hide speakers'}</button>
            </div>
            <div className="video_half">
              <div className="video_header">
                <h3 className="video_half--title">Junior Track 🤓</h3>
                <p className="video_half--talks p1">Talks #1 - #10</p>
                <p className='video_half--subtitle p1'>For Junior specialists</p>
              </div>
              <div className='speaker_items'>
                {this.props.speakersJunior.map((item, i) => <React.Fragment key={`videoPresent_item-${i}`}>{this.renderVideoPresent(item, i)}</React.Fragment>)}
                {!this.state.hideSpeakers && this.props.speakersJuniorHide.map((item, i) => this.renderVideoPresent(item, i))}
              </div>
              <button className='video_btn button' onClick={this.toggleSpeakers}>{this.state.hideSpeakers ? 'show more speakers' : 'Hide speakers'}</button>
              {/* <p className='more_speakers'>More speakers to be announced soon</p> */}
            </div>
          </div>
        </div>
      </>
    )
  }
}
